import React from "react";

export const AboutStrip = () => {
  return (
    <section
      className="bg-white py-16"
      style={{ borderBottom: "1px solid #E2E8F0" }}
      data-testid="about-strip"
    >
      <div className="max-w-2xl mx-auto px-5 sm:px-8 text-center">
        <div
          className="uppercase font-semibold"
          style={{
            color: "#1D9E75",
            fontSize: 12,
            letterSpacing: "0.12em",
          }}
        >
          About Meta Monk Ventures
        </div>
        <p
          className="mt-3"
          style={{
            color: "#1A202C",
            fontSize: 17,
            lineHeight: 1.65,
          }}
          data-testid="about-paragraph"
        >
          We are a Chennai-based multi-service financial distribution and
          technology firm. Our mission is to make wealth-building accessible,
          transparent, and intelligent for every Indian family.
        </p>
      </div>
    </section>
  );
};
